<template>
<div class="container-fluid">
    <div class="row">
        <Menu />
        <div class="col-md-10 mt-4">
            <h1> <i class="fa-thin fa-user"></i> Usuários Cadastrados</h1>
            <hr />
             <div class="cont">
                <Loading v-if="exibeLoading" />
    <table v-if="!exibeLoading" class="table">
    <thead>
        <tr>
        <th scope="col">Nome</th>
        <th scope="col">E-mail</th>
        <th scope="col">Editar</th>
        <th scope="col">Excluir</th>
        </tr>
    </thead>
    <tbody>
        <tr v-for="reck in dados">
        <td>{{ reck.name }}</td>
        <td>{{ reck.email }}</td>
        <td><i class="fa-solid fa-user-pen"></i></td>
        <td><i style="color:red" class="fa-solid fa-trash"></i></td>
        </tr>
    </tbody>
    </table>
    <RouterLink to="/usuario/novo" class="btn btn-primary"><i class="fa-thin fa-user-plus"></i> Usuário</RouterLink>
        </div>
        </div>
    </div>
</div>
</template>
<script setup>
import { ref } from "vue";
import Loading from "@/components/Loading.vue";
import Menu from "@/components/Menu.vue"
import Usuarios from "@/servicos/Usuarios";
import { RouterLink } from "vue-router";
const dados =  ref([])
const exibeLoading = ref(false)

const buscaUser = async () => {
    exibeLoading.value = true
    const response =  await Usuarios.UsuariosCadastrados()
    if(response){
        dados.value =  response
        exibeLoading.value=false
    }
}

buscaUser()

</script>
<style>

h1 { color:rgba(0,0,0,.8); font-weight: 400; font-size:20px !important;}
/* .table>:not(caption)>*>* { background-color:#1B3639;  } */
th {color:rgba(255,255,255,.9) !important; padding:10px !important;}
th { background-color: #1B3639 !important;}
.cont { background:#fff; padding: 10px; border:1px solid rgba(0,0,0,.1); box-shadow:1px 2px 3px rgba(0,0,0,.4); }

</style>